export default __webpack_public_path__ + "static/media/4.9129f342.jpg";